exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bn-input-label[data-v-19ded994]{font-size:17px;color:#979797}.fade-enter-active[data-v-19ded994],.fade-leave-active[data-v-19ded994]{transition:opacity .5s}.fade-enter[data-v-19ded994],.fade-leave-to[data-v-19ded994]{opacity:0}.forgalmi-prefix[data-v-19ded994]{display:inline-block;font-weight:700;background:var(--v-primary-base)!important;color:#fff;padding:0 1px;margin:50% 2px 0 0;line-height:20px;font-size:16px;width:30px}", ""]);

// exports
